import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.from-entries.js";
import { isValidStyleProperty } from '../../../core/utilities/swan-style.utils.js';
import { className } from '../../../core/utilities/classnames.utils.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';
import { iterToSet } from '../../../core/utilities/transform.utils.js';
/**
 * FOR DP, it could be undefined by the configuration,
 * in that case, it would result in type undefined, as defaults in createComponent
 */

function getDerivedProps(derivedProps, props) {
  if (typeof derivedProps === 'function') {
    return derivedProps(props);
  }

  return derivedProps;
}

function getProcessedProps(processProps, props, derivedProps) {
  if (typeof processProps === 'function') {
    return processProps(props, derivedProps);
  }

  return props;
}

function getDefaultClassNameIterable(classNames, props, derivedProps) {
  if (!classNames) return null;

  if (typeof classNames === 'function') {
    return classNames(props, derivedProps);
  } // If the defaultClassname is not a function, it could share the initial classnames with multiple instances
  // Hence, creating a new set.
  // Additionally, inside renderElement, it would be sent to process Styles which would re-use this.


  return new Set(classNames);
} // Filter Props


var commonPropKeys = new Set(['as', 'component', 'render', 'swanStyle', 'className', 'children', 'htmlSize', '__dangerouslySuppressWarning', 'experiment']);

function isValidGlobalProps(key) {
  return commonPropKeys.has(key);
}

function shouldFilterPropKeyFactory(filterPropKeys) {
  if (!filterPropKeys) return function () {
    return false;
  };
  var filterPropKeySet = iterToSet(filterPropKeys);
  return function shouldFilterPropKey(key) {
    return filterPropKeySet.has(key);
  };
}

function filterProps(props, filterPropKeys, classNameIterable) {
  var shouldFilterPropKey = shouldFilterPropKeyFactory(filterPropKeys);
  var filteredPropsEntries = Object.entries(props).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return !(isValidStyleProperty(key) || isValidGlobalProps(key) || shouldFilterPropKey(key));
  });
  var classes = className(props.className, classNameIterable ? Array.from(classNameIterable) : null);
  if (classes) filteredPropsEntries.push(['className', classes]);
  var htmlSize = props['htmlSize'];
  if (htmlSize !== undefined) filteredPropsEntries.push(['size', htmlSize]);
  return Object.fromEntries(filteredPropsEntries);
}

function wrap(wrapper, props, derivedProps) {
  return function (element) {
    return wrapper(props, derivedProps, element);
  };
}

function getProps(userProps, propConfig, filterPropKeys) {
  var _ref3 = propConfig || {},
      derivedProps = _ref3.derivedProps,
      processProps = _ref3.processProps,
      classNames = _ref3.classNames,
      wrapRoot = _ref3.wrapRoot,
      wrapChildren = _ref3.wrapChildren;

  var derivedExtraProps = getDerivedProps(derivedProps, userProps);
  var processedProps = getProcessedProps(processProps, userProps, derivedExtraProps);
  var defaultClassNameIterable = getDefaultClassNameIterable(classNames, processedProps, derivedExtraProps);
  var classNameIterable = processStyleProps(processedProps, defaultClassNameIterable);
  var filteredProps = filterProps(processedProps, filterPropKeys, classNameIterable);
  return {
    processedProps: processedProps,
    props: filteredProps,
    wrapRoot: wrapRoot ? wrap(wrapRoot, processedProps, derivedExtraProps) : null,
    children: wrapChildren ? wrapChildren(processedProps, derivedExtraProps, processedProps.children) : processedProps.children
  };
}

export { filterProps, getDefaultClassNameIterable, getDerivedProps, getProcessedProps, getProps, wrap };